import React, { useState, useEffect } from "react";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import URL from "../../../constant/URL";
import TYPE from "../../../constant/TYPE";
import http from "../../../http/http";
import SearchBar from "./SearchBar";
import Stage from "./Stage";

const languageTempData = [
  { label : '한국어', data : 'KO' },
  { label : '영어', data : 'EN' },
  { label : '중국어', data : 'CH' },
  { label : '일본어', data : 'JP' }
];

const searchTypeData = [
  { label : '소주제명', data : TYPE.SEARCH.STAGE_NAME },
  { label : '소주제코드', data : TYPE.SEARCH.STAGE_CODE },
  { label : '문항코드', data : TYPE.SEARCH.QUESTION_CODE }
];

const List = () => {

  const [ data, setData ] = useState( [] );
  const [ languageData, setLanguageData ] = useState( [] );
  const [ language, setLanguage ] = useState( {} );
  const [ searchType, setSearchType ] = useState( {} );
  const [ searchKeyword, setSearchKeyword ] = useState( '' );

  const history = useHistory();
  const location = useLocation();

  const { i18n } = useTranslation();

  useEffect( () => {
    setLanguageData( languageTempData );
    setLanguage( languageTempData[ 0 ] );
    setSearchType( searchTypeData[ 0 ] );
    /*http.request( {
      url : URL.API.QSTISP.CODE.LANGUAGE,
      success : ( data ) => {
        const languageData = data.map( v => ( { label : v.cdNm, data : v.cmnCd } ) );
        setLanguageData( languageData );
        setLanguage( languageData[ 0 ] );
        setSearchType( searchTypeData[ 0 ] );
      }
    } );*/
  }, [] );

  useEffect( () => {
    if ( languageData.length && location.search ) {
      const parameter = queryString.parse( location.search );
      const language = languageData.filter( v => parameter.language === v.data )[ 0 ] || languageData[ 0 ];
      const searchType = searchTypeData.filter( v => parameter.searchType === v.data )[ 0 ] || searchTypeData[ 0 ];
      const searchKeyword = parameter.searchKeyword || '';
      localStorage.setItem( 'locale', language.data );
      i18n.changeLanguage( language.data.toLowerCase() );
      setLanguage( language );
      setSearchType( searchType );
      setSearchKeyword( searchKeyword );
      http.request( {
        url : `${ URL.API.QSTISP.STAGE }?langCd=${ language.data }&srchTy=${ searchType.data }&srchTxt=${ searchKeyword }`,
        success : setData
      } );
    }
  }, [ languageData, location.search ] );

  const updateURL = () => {
    history.push( `${ URL.QUESTION_INSPECTION.LIST }?language=${ language.data }&searchType=${ searchType.data }&searchKeyword=${ searchKeyword }` );
  };

  const STAGES = data.map( ( v, i ) => <Stage key={ i } data={ v } /> );

  return (
    <div className="layout-def tab-wrap layout-sl layout-my bg_gray2 inspection">
      <div className="container">
        <div className="inner">
          <SearchBar
            languageData={ languageData }
            language={ language }
            onChangeLanguage={ setLanguage }
            searchTypeData={ searchTypeData }
            searchType={ searchType }
            onChangeSearchType={ setSearchType }
            searchKeyword={ searchKeyword }
            onChangeSearchKeyword={ setSearchKeyword }
            onSearch={ updateURL }
          />
          <div className="progress_study">
            <ul className="sl-section_list gm">{ STAGES }</ul>
          </div>
        </div>
      </div>
    </div>
  );

};

export default List;
